import styled from 'styled-components';

import { rem } from '../../../core';

const FieldsetStyled = styled.fieldset`
  padding: 0;
  margin: 0 0 1rem;
  border: 0;

  legend {
    margin-bottom: ${rem(8)};
    font-weight: 400;
  }

  p {
    margin-bottom: ${rem(15)};
  }

`;

export default FieldsetStyled;
